import React, { type FC, type JSX } from 'react';
import { CloseIconContainer, HeaderWrapper, ModalHeaderContainer } from './styled';
import CloseIcon from '../../CloseIcon';
import { HeaderTitle, useCloseLabel } from '../modalHeaderCommon';

type ModalHeaderProps = {
  handleClose?: () => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  showShadow?: boolean;
  align?: 'center' | 'left';
  subHeader?: React.ReactNode;
  // Accessible name for the icon-only close button. Defaults to the translated "Close";
  // pass a descriptive one (e.g. "Close Your trip") so screen readers announce context.
  closeLabel?: string;
  // Decorative extras such as a loading line, drawn in the header bar after the title and outside the heading.
  adornment?: React.ReactNode;
};

const BasicModalHeaderV2: FC<ModalHeaderProps> = ({
  children,
  className = '',
  handleClose,
  style,
  showShadow,
  align = 'center',
  subHeader,
  closeLabel,
  adornment,
}): JSX.Element => {
  const closeName = useCloseLabel(closeLabel);
  return (
    <HeaderWrapper className={className} $showShadow={showShadow}>
      <ModalHeaderContainer style={style} $align={align}>
        {handleClose && (
          <CloseIconContainer
            type="button"
            aria-label={closeName}
            data-swipe-dismiss-ignore={true}
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.stopPropagation();
              handleClose();
            }}
          >
            <CloseIcon />
          </CloseIconContainer>
        )}
        <HeaderTitle>{children}</HeaderTitle>
        {adornment}
      </ModalHeaderContainer>
      {subHeader}
    </HeaderWrapper>
  );
};

export default BasicModalHeaderV2;
